import { useEffect, useLayoutEffect } from 'react';

import { environmentConfig } from '../../configs/EnvironmentConfig';

export const useIsomorphicLayoutEffect = environmentConfig.IS_SSR ? useEffect : useLayoutEffect;
